export const ApiUrl = 'https://api.restaurant.rankriseseo.co.uk/api'


export function formatToPakistaniCurrency(amount) {
  return new Intl.NumberFormat('en-PK', {
      style: 'currency',
      currency: 'PKR',
      minimumFractionDigits: 0
  }).format(amount);
}